// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactIcons_wrapper__qJRec","icon":"ContactIcons_icon__5l3rw","title":"ContactIcons_title__sVj46","description":"ContactIcons_description__dqxhT"};